<template>
    <div class="row">
        <div class="col-sm-12" v-if="!detail">
            <table  class="table table-hover table-striped" >
                <thead class="btn-info">
                <tr>
                    <th style="padding: 10px; width: 120px">DATA</th>
                    <th style="padding: 10px">TITULO</th>
                    <th style="padding: 10px">PROXIMIDADE</th>
                    <th style="padding: 10px; width: 100px"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="d in details">
                    <td style="vertical-align: middle">{{ d.date_time_evento | date("DD-MM-YYYY HH:mm:ss") }}</td>
                    <td style="vertical-align: middle">{{ d.titulo }}</td>
                    <td style="vertical-align: middle">{{ d.proximidade }}</td>
                    <td>
                        <button @click="loadPosicao(d)" type="button" class="btn btn-sm btn-block btn-success">Ver Posição</button>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
        <div class="col-sm-12" v-else>
            <div class="row" style="height : calc(100vh - 300px)" v-if="det">
                <div class="col-sm-6">
                    <h5>
                        <a :href="'https://www.google.com.br/maps/place/' + detail.lat + ',' + detail.long + '/@' + detail.lat + ',' + detail.long + ',17.79z'" target="_blank" style="padding-right: 10px">
                            <img src="/assets/img/google-maps.png" style="height: 30px">
                        </a>
                        <button @click="clear()" type="button" class="btn btn-xs btn-default">VOLTAR</button> {{ det.titulo }}
                    </h5>
                    <posicao-atual :posicao="detail"/>
                </div>
                <div class="col-sm-6" >
                    <table  class="table table-hover table-striped">
                        <thead class="btn-info">
                        <tr>
                            <th style="padding: 10px">MAPA</th>
                        </tr>
                        </thead>
                    </table>
                    <map-posicao :height="'calc(100vh - 400px)'" :posicao="detail"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Alerts } from '../../class/alerts';
    import PosicaoAtual from '../admin/partials/PosicaoAtual.vue';
    import { Tracking } from '../../class/tracking';
    import MapPosicao from '../admin/partials/MapPosicao.vue';
    import { date } from "../../filter";

    export default {
        name: 'EventosAlertas',
        props: {
            id: {
                default: null
            }
        },

        filters: {
          date
        },

        components: {
            PosicaoAtual, MapPosicao,
        },

        data () {
            return {
                details: [],
                detail: null,
                det: null
            }
        },

        beforeMount() {
            this.loadDetails(this.id);
        },

        methods: {

            async loadPosicao (det) {
                this.det = det;
                this.detail = await Tracking.byPK(det.id_tracking);
            },

            clear() {
                this.detail = null;
                this.det = null;
            },

            async loadDetails(id) {
                try {
                    this.details = await Alerts.details(id);
                } catch (e) {
                    console.error(e);
                }
            },
        }
    };
</script>

<style scoped>

</style>
